/* eslint-disable unicorn/no-null */
import { useEffect, useState } from 'react';
// mantine
import { Select } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
// utils
import { TSessionsData } from '@newo/api/gateway';

import { FIELD_CHANGE_DEBOUNCE_DELAY } from '@/pages/Sessions/Sessions.utils.ts';

interface ResultSuccessSelectProps {
    sessionId: string;
    value: number | null;
    onSave: (sessionId: string, data: TSessionsData) => void;
}

const ResultSuccessSelect = ({
    sessionId,
    value,
    onSave
}: ResultSuccessSelectProps) => {
    const [result, setResult] = useState<string | null>(
        value === null ? '' : `${value}`
    );
    const [debounced] = useDebouncedValue(
        result === '' ? null : Number(result),
        FIELD_CHANGE_DEBOUNCE_DELAY
    );
    useEffect(() => {
        if (debounced !== value) {
            onSave(sessionId, {
                agent_success_human: debounced
            });
        }
    }, [debounced, onSave, sessionId, value]);

    return (
        <Select
            className="z-0"
            data={[
                { label: 'Success-A', value: '1' },
                { label: 'Success-B', value: '2' },
                { label: 'No', value: '0' },
                { label: 'N/A', value: '' }
            ]}
            size="xs"
            value={result}
            onChange={setResult}
        />
    );
};

export default ResultSuccessSelect;
